import {useContext} from "react";
import {HeaderContext, HeaderContextType} from "../context/HeaderContext";


export function useHeaderComponent() : HeaderContextType {
    return useContext(HeaderContext);
}
